import { defineField, defineType } from "sanity";
import { SectionAnchorInput } from "../../components/SectionAnchorInput";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "sectionAnchorLink",
  title: "Section Anchor Link",
  type: "object",
  preview: {
    select: {
      title: "title"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title)
      };
    }
  },
  fields: [
    {
      type: "multilingualArrayString",
      name: "title",
      title: "Title",
      validation: (Rule) => Rule.required()
    },
    defineField({
      type: "string",
      name: "target",
      title: "Target",
      components: {
        input: SectionAnchorInput
      }
    })
  ]
});
